module.exports = __webpack_public_path__ + "img/生物多样性保护平台.8fe3ea38.png";